import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormGroup,
  FormLabel,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import { ChangeEvent } from "react";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import { useNormalizedOptions } from "../select/UseNormalizedOptions";

interface MultiCheckboxProps {
  label: string;
  options: Option[] | string[];
  maxHeight?: string;
  maxWidth?: string;
}

// NOTE: This is pretty much set up to handle the PINE filters only right now
// It needs some love before this is an actually reusable component
// Currently it bakes in some assumptions about the styling and structure that it
// will be used with and we should work to eliminate those to make it more generic
const MultiCheckbox = ({
  label,
  options,
  maxHeight = "100%",
  maxWidth = "100%",
}: MultiCheckboxProps) => {
  const normalizedOptions = useNormalizedOptions(options);
  const field = useFieldContext<string[]>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    const value = e.target.value.toString();

    if (checked) {
      field.pushValue(value);
    } else {
      const index = field.state.value.findIndex((opt) => opt === value);
      field.removeValue(index);
    }
  };

  const handleButtonClick = () => {
    if (field.state.value.length === 0) {
      field.setValue(normalizedOptions.map((opt) => opt.value.toString()));
    } else {
      field.clearValues();
    }
  };

  const buttonLabel =
    field.state.value.length === 0 ? "Check All" : "Uncheck All";

  return (
    <FormControl
      component="fieldset"
      variant="standard"
      sx={{ maxWidth: maxWidth }}
    >
      <FormLabel component="legend" color="secondary">
        {label}
      </FormLabel>

      <FormGroup>
        <Stack maxHeight={maxHeight} flexWrap="wrap" rowGap={0.5} columnGap={1}>
          {normalizedOptions.map((opt) => (
            <FormControlLabel
              key={opt.value}
              checked={field.state.value.includes(opt.value.toString())}
              value={opt.value.toString()}
              control={
                <Checkbox
                  onChange={handleChange}
                  name={opt.value.toString()}
                  size="small"
                  sx={{
                    p: "2px",
                  }}
                />
              }
              label={<Typography fontSize={13}>{opt.label}</Typography>}
              sx={{
                "&.MuiFormControlLabel-root": {
                  m: 0,
                  maxWidth: "50%", // NOTE: this will probably not be great as a reasonable default
                },
              }}
            />
          ))}
        </Stack>

        <Button
          size="small"
          variant="outlined"
          onClick={handleButtonClick}
          sx={{ mt: 1 }}
        >
          {buttonLabel}
        </Button>
      </FormGroup>
    </FormControl>
  );
};

export default MultiCheckbox;
